import {getMethod} from '~/api'

async function get(request, cancelToken) {
    return await getMethod('/proxy/searchPackageTours', request, cancelToken)
}

export {get}
